/**
 * The minimum severity of log message forwarded to a remote sink (Rollbar or New Relic).
 *
 * Levels are cumulative in ascending verbosity - Warning forwards warnings
 * and errors, Info forwards info, warnings, and errors, and so on. Off
 * disables the sink entirely.
 */
export enum LogLevel {
    Off = "OFF",
    Error = "ERROR",
    Warning = "WARNING",
    Info = "INFO",
    Debug = "DEBUG",
}

/**
 * @deprecated Use {@link LogLevel}. Alias kept so existing `RollbarLogLevel` imports keep compiling (value and type).
 */
export { LogLevel as RollbarLogLevel };
